import { DataService } from './../data.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { ExcelService } from '../excel.service';

declare var toastr: any
declare var Nanobar: any
declare var $: any

@Component({
  selector: 'app-import-products',
  templateUrl: './import-products.component.html',
  styleUrls: ['./import-products.component.css']
})
export class ImportProductsComponent implements OnInit {

  @ViewChild('importFile') importFile: ElementRef;

  nao = new Nanobar();

  // HTML variables
  loading: boolean = true;
  businessesList: any [] = [];

  // Searching variables
  searchTimeOut: any;

  // API variables
  import: {
    businessesList: any [];
    selectedBusinessId: number,
    searchBusinessString: string,
    importType: string,
    lookUpBy: string,
    productFile: File,
    productList: any [],
    totalChunks: number,
    chunkLimit: number,
    uploadedChunks: number,
    uploadProgress: number,
    createdProducts: string[],
    failedProducts: string[],
    duplicateProducts: string[],
    nonExistentProducts: string[],
    updatedProducts: string[],
    stopUpload: boolean,
    uploadCompleted: boolean
  } = {
      businessesList: [],
      selectedBusinessId: undefined,
      searchBusinessString : '',
      importType:'add/update',
      lookUpBy: 'variant_id',
      productFile: undefined,
      productList: [],
      totalChunks: 0,
      chunkLimit: 10,
      uploadedChunks: 0,
      uploadProgress: 0,
      createdProducts: [],
      failedProducts: [],
      duplicateProducts: [],
      nonExistentProducts: [],
      updatedProducts: [],
      stopUpload: false,
      uploadCompleted: false
    };

  migrate: {
    parentbBusinessesList: any [];
    categoryList: any [];
    targetBusinessesList: any [];
    selectedParentBusinessId: number,
    selectedBusinessIds: number[],
    selectedCateforiesIds: number[],
    parentSearchString: string,
    categorySearchString: string,
    targetSearchString: string,
    showCategoryView: boolean,
    categoryViewMessage: string,
  } = {
    parentbBusinessesList: [],
    categoryList: [],
    targetBusinessesList: [],
    selectedParentBusinessId: undefined,
    selectedBusinessIds: [],
    selectedCateforiesIds: [],
    parentSearchString: '',
    categorySearchString: '',
    targetSearchString: '',
    showCategoryView: false,
    categoryViewMessage: 'Select Parent Business to view Categories ...',
  }

  export: {
    businessList: any [],
    categoryList: any [],
    businessSearchString: string,
    categorySearchString: string,
    selectedBusinessId: number,
    selectedBusinessName:string,
    selectedCategoriesIds: number [],
    categoryViewMessage: string,
    productList: any []
  } = {
    businessList: [],
    categoryList: [],
    businessSearchString: '',
    categorySearchString: '',
    selectedBusinessId: undefined,
    selectedBusinessName:'',
    selectedCategoriesIds: [],
    categoryViewMessage: 'Select a Business to view Categories ...',
    productList: []
  }

  constructor(private dataService: DataService, private excelService: ExcelService,) {}

  ngOnInit() {
    this.getBusinessListing();
    this.getCategoryListing();
  }

  getBusinessListing() {
    this.dataService.getdispensaryListing(localStorage.getItem('token')).subscribe(
      (data: any) => {
        this.businessesList = data;
        this.import.businessesList = this.businessesList;
        this.migrate.parentbBusinessesList = this.businessesList;
        this.migrate.targetBusinessesList = this.businessesList;
        this.export.businessList = this.businessesList;
        console.log('check1',this.export.businessList)
        this.loading = false;
      },
      (error) => {
        console.log('error', error);
        toastr.error('Something went wrong');
        this.loading = false;
      }
    );
  }

  // ******************************** Import Tab Functions ********************************
  searchSpecificBusinessForImport() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30)
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), -1, this.import.searchBusinessString).subscribe(
        (data: any) => {
          this.nao.go(100)
          this.import.businessesList = data;
        },
        (error) => {
          this.nao.go(100)
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
      );
    }, 1000);
  }

  onImportBusinessClick(event, business_id: number) {
    this.import.selectedBusinessId = business_id;
    console.log("selected business IDs ====> ", this.import.selectedBusinessId)
  }

  /**
   * This function receives a CSV File and extracts products list/Array
   * @param file will be a CSV File of products
   */
  onChangeFile(file) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    this.import.productFile = file;
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        // console.log('name', sheet)
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.import.productList = jsonData['Sheet1'];
      console.log('product List ===> ',this.import.productList);
      if(this.import.productList.length) {
        this.calculateChunks();
      } else {
        toastr.error('The CSV file doesnt have any valid data')
      }
    }
  }

  calculateChunks() {
    this.import.totalChunks = this.import.productList.length / this.import.chunkLimit;
    let remainingProducts = this.import.productList.length % this.import.chunkLimit;
    if(remainingProducts > 0) this.import.totalChunks = this.import.totalChunks + 1;
    this.import.totalChunks = Math.floor(this.import.totalChunks);
    console.log(this.import.totalChunks, remainingProducts);
  }

  ImportValidation() {
    if(!this.import.selectedBusinessId) return toastr.error('Select a business!');
    if(!this.import.importType) return toastr.error('Select an import option!');
    if(!this.import.lookUpBy) return toastr.error("Select a 'look up' option!");
    if(!this.import.productFile) return toastr.error('Select a CSV file to import!');
    if(!this.import.productList.length) return toastr.error('The CSV file doesnt have any valid data');
    $('#confirmImport').modal('show');
  }

  ImportButtonClick() {
    $('#productUploadProgressModal').modal('show');
    this.sendProducts(0, this.import.chunkLimit);
  }

  /**
   * This function takes the 2 parameters and extracts a sub-array accordingly.
   * That array is sent uploaded. on 'success', stats and over-all progress is maintained.
   * The function calls itself until all products have been uploaded or an error occurs.
   * @param from start index of the product array
   * @param to end index of the product array
   */
  sendProducts(from: number, to: number) {
    var productList = this.import.productList.slice(from, to);
    this.nao.go(30);
    if(productList.length && !this.import.stopUpload) {
      this.dataService.importProducs(localStorage.getItem('token'), this.import.selectedBusinessId, this.import.importType, this.import.lookUpBy, productList).subscribe((data) => {
        if(data['success'] == true) {
          this.nao.go(100);
          this.import.createdProducts = [...this.import.createdProducts, ...data['created_products']]
          this.import.duplicateProducts = [...this.import.duplicateProducts, ...data['duplicate_products']]
          this.import.nonExistentProducts = [...this.import.nonExistentProducts, ...data['non_existent_products']]
          this.import.updatedProducts = [...this.import.updatedProducts, ...data['updated_products']]

          // ** update sent chunks and overall progress.
          this.import.uploadedChunks = this.import.uploadedChunks + 1;
          this.import.uploadProgress = (this.import.uploadedChunks / this.import.totalChunks) * 100;
          this.sendProducts(from + this.import.chunkLimit, to + this.import.chunkLimit);
        }
      }, (error) => {
        this.import.stopUpload = true;
        toastr.error('Something went wrong!');
        this.nao.go(100);
      });
    } else {
      this.nao.go(100);
      if(this.import.stopUpload) {
        toastr.error('Upload Canceled');
      } else {
        this.import.uploadCompleted = true;
        toastr.success('Product Import Complete');
      }
    }
  }

  closeUploadProgressModal() {
    this.import = {
      businessesList: this.import.businessesList,
      selectedBusinessId: undefined,
      searchBusinessString : '',
      importType:'add/update',
      lookUpBy: 'variant_id',
      productFile: null,
      productList: [],
      totalChunks: 0,
      chunkLimit: 10,
      uploadedChunks: 0,
      uploadProgress: 0,
      createdProducts: [],
      failedProducts: [],
      duplicateProducts: [],
      nonExistentProducts: [],
      updatedProducts: [],
      stopUpload: false,
      uploadCompleted: false
    };
    this.importFile.nativeElement.value = "";
    $('#productUploadProgressModal').modal('hide');
  }

  // ******************************** Migrate Tab Functions ********************************

  searchSpecificBusinessForMigrationParent() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30)
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), -1, this.migrate.parentSearchString).subscribe(
        (data: any) => {
          this.nao.go(100)
          this.migrate.parentbBusinessesList = data;
        },
        (error) => {
          this.nao.go(100)
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
        );
      }, 1000);
  }

  searchSpecificBusinessForMigrationTarget() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30)
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), -1, this.migrate.targetSearchString).subscribe(
        (data: any) => {
          this.nao.go(100)
          this.migrate.targetBusinessesList = data;
        },
        (error) => {
          this.nao.go(100)
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
        );
      }, 1000);
  }

  onParentBusinessClick(event, business_id: number) {
    this.migrate.selectedParentBusinessId = business_id;
    this.migrate.selectedCateforiesIds = [];
    this.getCategoryListing();
  }

  getCategoryListing() {
    this.migrate.categoryViewMessage = 'Loading Categories ...'
    this.dataService.getCateogryList(localStorage.getItem('token'), this.migrate.selectedParentBusinessId).subscribe(
      (data: any) => {
        this.migrate.categoryList = data.items;
        if(!this.migrate.categoryList || this.migrate.categoryList.length < 1) {
          this.migrate.categoryViewMessage = 'Selected Business does not have any categories.';
          return;
        }
        this.migrate.categoryViewMessage = '';
      },
      (error) => {
        console.log('error', error);
        toastr.error('Something went wrong');
      }
    );
  }

  onTargetBusinessClick(event, business_id: number) {
    var checked = event.target.checked;
    if(checked) {
      this.migrate.selectedBusinessIds.push(business_id);
    } else {
      this.migrate.selectedBusinessIds.splice(this.migrate.selectedBusinessIds.lastIndexOf(business_id), 1);
    }
  }

  onParentCategoryClick(event, category_id: number) {
    var checked = event.target.checked;
    if(checked) {
      this.migrate.categoryList.push(category_id);
    } else {
      this.migrate.categoryList.splice(this.migrate.categoryList.lastIndexOf(category_id), 1);
    }
  }

  searchSpecificCategoryForMigrate() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30)
      this.dataService.searchCategory(localStorage.getItem('token'), this.migrate.categorySearchString, this.migrate.selectedParentBusinessId).subscribe(
        (data: any) => {
          this.nao.go(100)
          this.migrate.categoryList = data.items;
        },
        (error) => {
          this.nao.go(100)
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
        );
      }, 1000);
  }

  // *********************************** Export Tab Functions ******************************************

  searchSpecificBusinessForExport() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30)
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), -1, this.export.businessSearchString).subscribe(
        (data: any) => {
          this.nao.go(100)
          this.export.businessList = data;
        },
        (error) => {
          this.nao.go(100)
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
        );
      }, 1000);
  }

  onExportBusinessClick(event, business_id: number,businessName) {
    this.export.selectedBusinessName = businessName
    this.export.selectedBusinessId = business_id;
    this.export.selectedCategoriesIds = [];
    this.getCategoryListingForExportBusiness();
  }

  getCategoryListingForExportBusiness() {
    this.export.categoryViewMessage = 'Loading Categories ...'
    this.dataService.getCateogryList(localStorage.getItem('token'), this.export.selectedBusinessId).subscribe(
      (data: any) => {
        this.export.categoryList = data.items;
        if(this.export.categoryList.length < 1) {
          this.export.categoryViewMessage = 'Selected Business does not have any categories.';
          return;
        }
        this.export.categoryViewMessage = '';
      },
      (error) => {
        console.log('error', error);
        toastr.error('Something went wrong');
      }
    );
  }

  searchSpecificCategoryForExport() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30)
      this.dataService.searchCategory(localStorage.getItem('token'), this.export.categorySearchString, this.export.selectedBusinessId).subscribe(
        (data: any) => {
          this.nao.go(100)
          this.export.categoryList = data.items;
        },
        (error) => {
          this.nao.go(100)
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
        );
      }, 1000);
  }

  onCategoryClickForExport(event, category_id: number) {
    var checked = event.target.checked;
    if (checked) {
      this.export.selectedCategoriesIds.push(category_id);
    } else {
      this.export.selectedCategoriesIds.splice(this.export.categoryList.lastIndexOf(category_id), 1);
    }
  }

  exportProducts() {
    this.nao.go(30);
    this.dataService.exportProducs(localStorage.getItem('token'), this.export.selectedBusinessId, this.export.selectedCategoriesIds).subscribe(res => {
      this.nao.go(100);
      this.export.productList = res['product_list'];
      if(this.export.productList.length ==0){
        toastr.error('No products found for the selected categories')
      }
      else{
        this.excelService.exportAsExcelFile(this.export.productList, this.export.selectedBusinessName);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/import-products/import-products.component.ts